export default "__VITE_ASSET__c862f186__"